module.exports = __webpack_public_path__ + "static/service-boundary-3-328370e51f8be80637c3ea74bbc2d6de.png";